import { Button } from '@klear/ui/components/button'
import { Modal } from '@klear/ui/components/modal'
import type { CommitEntry } from '@/app/document-review/commit-summary'

export type ApproveModalProps = {
  open: boolean
  isPending: boolean
  title: string
  pendingLabel: string
  entries: CommitEntry[]
  notes: string[]
  onOpenChange: (open: boolean) => void
  onApprove: () => void
}

export function ApproveModal({
  open,
  isPending,
  title,
  pendingLabel,
  entries,
  notes,
  onOpenChange,
  onApprove
}: ApproveModalProps) {
  const close = () => {
    if (isPending) return
    onOpenChange(false)
  }

  return (
    <Modal
      size="sm"
      open={open}
      onOpenChange={(next) => {
        if (!next) close()
      }}
      title={title}
      description="Everything this adds to Klear, before it happens."
      footer={
        <div className="flex w-full flex-row-reverse items-center gap-2">
          <Button autoFocus onClick={onApprove} disabled={isPending}>
            {isPending ? pendingLabel : title}
          </Button>
          <Button variant="outline" onClick={close} disabled={isPending}>
            Cancel
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        <div className="bg-card overflow-hidden rounded-md border">
          <table className="w-full text-sm">
            <tbody className="divide-y">
              {entries.map((entry, index) => (
                <tr key={`${entry.action}-${entry.what}-${index}`}>
                  <td className="text-muted-foreground w-24 px-3 py-2 align-baseline">{entry.action}</td>
                  <td className="px-3 py-2 align-baseline">{entry.what}</td>
                  <td className="px-3 py-2 text-right align-baseline font-mono tabular-nums">{entry.amount ?? ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {notes.map((note) => (
          <p key={note} className="text-muted-foreground text-sm">
            {note}
          </p>
        ))}

        <p className="text-sm font-medium">This happens immediately and cannot be undone. Enter confirms.</p>
      </div>
    </Modal>
  )
}
